import { render, staticRenderFns } from "./tableFeatures.vue?vue&type=template&id=6cc6184c&"
import script from "./tableFeatures.vue?vue&type=script&lang=js&"
export * from "./tableFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports